var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('BaseTabPanel',{attrs:{"tabs":_vm.tabs,"active-tab":_vm.activeTab,"is-underlined":_vm.isUnderlined,"is-unpadded":_vm.isUnpadded},on:{"setActive":_vm.setActive}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }